// src/utils/firebaseFunctions.ts
//
// Helper for calling BarFunFinder's Firebase Cloud Functions from the React dashboard.
// getFunctions() with no arguments automatically uses the Firebase app that's
// already set up elsewhere in this project (the same one `db` comes from) —
// no extra config needed here.

import { getFunctions, httpsCallable } from "firebase/functions";

export interface DraftEvent {
  itemType: "event" | "special";
  title: string;
  details: string;
  needsReview: boolean;
  reviewNote?: string;

  // event-only fields
  dayOfWeek?: string;
  time?: string;
  category?: "Gambling" | "Entertainment" | "Sports" | "Other";

  // shared field, different meaning per type
  recurrence?: string;

  // special-only fields
  specialCategory?: "Daily Food" | "Daily Drink" | "Happy Hour" | "Late Night" | "Birthday";
  days?: string[];
  startTime?: string;
  endTime?: string;
}

interface ExtractEventsResponse {
  barId: string;
  scannedBy: string;
  draftEvents: DraftEvent[];
}

interface ExtractEventsInput {
  imageBase64: string;
  mediaType: string;
  barId: string;
}

const functions = getFunctions();

export async function extractEventsFromCalendarImage(
  input: ExtractEventsInput
): Promise<ExtractEventsResponse> {
  const callable = httpsCallable<ExtractEventsInput, ExtractEventsResponse>(
    functions,
    "extractEventsFromCalendarImage"
  );
  const result = await callable(input);
  return result.data;
}
